import { css as _css } from "@emotion/react";
import LinkOut from '~icons/akar-icons/link-out';
import { theme } from '@arc/frontend/ui-theme';
export function LinkOutIcon({
  link
}) {
  return <a href={link} target="_blank" rel="noopener noreferrer" css={/*#__PURE__*/_css({
    color: theme.colors.lightBlue
  }, process.env.NODE_ENV === "production" ? "" : ";label:LinkOutIcon;")}>
			<LinkOut strokeWidth={2} width={22} height={22} />
		</a>;
}